module.exports = __webpack_public_path__ + "static/media/externalLinkIcon.013f82f5.svg";